<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>{{abendschauWetterbericht?.caption_europa}}</h3>
    {{abendschauWetterbericht?.wx_europa}}
  </div>
  <div class="bericht-text-container">
    <h3>{{abendschauWetterbericht?.caption_wolkenfilm}}</h3>
    {{abendschauWetterbericht?.wx_wolkenfilm}}
  </div>
  <div class="bericht-text-container">
    <h3>{{abendschauWetterbericht?.caption_franken}}</h3>
    {{abendschauWetterbericht?.wx_franken}}
  </div>
  <div class="bericht-text-container">
    <h3>{{abendschauWetterbericht?.caption_niederbayern_oberpfalz}}</h3>
    {{abendschauWetterbericht?.wx_niederbayern_oberpfalz}}
  </div>
  <div class="bericht-text-container">
    <h3>{{abendschauWetterbericht?.caption_oberbayern_schwaben}}</h3>
    {{abendschauWetterbericht?.wx_oberbayern_schwaben}}
  </div>
  <div class="bericht-text-container">
    <h3>{{abendschauWetterbericht?.caption_wx_next_days}}</h3>
    {{abendschauWetterbericht?.wx_next_days}}
  </div>
  <div class="bericht-text-container">
    {{abendschauWetterbericht?.footer}}
  </div>
</div>
